export default __webpack_public_path__ + "static/media/Avatar-28.3227fa70.svg";